<template>
<div class="chapter">
<div class="inner_page">
<a id="page_viii"></a>
<p class="dedi2t">“For I have sworn thee fair, and thought thee bright,</p>
<p class="dedi2">Who art as black as hell, as dark as night.”</p>
<p class="dedi3">—William Shakespeare,</p>
<p class="dedi2">Sonnet CXLVII</p>
<a id="page_ix"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Dedication3.vue?503082e5